import Hero from "../../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageOverpaymentCalculator from "../../calculators/OverpaymentCalculator";
import SEO from "../../designSystem/SEO";

const MortgageOverpaymentCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Overpayment Calculator"
        description="See how mortgage overpayments could reduce your balance, interest costs and mortgage term with AK Mortgages."
        path="/calculators/overpayment"
      />
      <Hero
        title="Overpayment"
        subtitle=""
        showContactButton={false}
        // backgroundImage={CalculatorsImag1}
      />
      <MortgageOverpaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageOverpaymentCalculatorsPage;
